import CheckboxList from 'components/Drawer/CheckboxList';
import LabelledCheckbox from 'components/form/Inputs/LabelledCheckbox';
import { DropDownSelector } from './components';

type Props<T extends string> = {
  columnList: readonly T[];
  columns: Record<T, boolean>;
  setColumns: (columns: Record<T, boolean>) => void;
};
function Columns<T extends string>({
  columnList,
  columns,
  setColumns,
}: Props<T>): React.ReactElement {
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setColumns({
      ...columns,
      [e.target.name]: !!e.target.checked,
    });
  };
  return (
    <DropDownSelector title="Colonnes à exporter">
      <CheckboxList>
        {columnList.map((column) => (
          <LabelledCheckbox
            label={column}
            name={column}
            checked={!!columns[column]}
            onChange={handleChange}
          ></LabelledCheckbox>
        ))}
      </CheckboxList>
    </DropDownSelector>
  );
}

export default Columns;
